<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title class="card-header__title-container">
      <mat-icon class="mat-icon-xl">person</mat-icon>
      <h2 class="card-header__heading">{{data.firstName}} {{data.lastName}}</h2>
    </mat-card-title>
    <button *ngIf="edit"
            mat-mini-fab
            class="edit-button"
            color="primary"
            routerLink="/customer/{{data.id}}"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="no-bottom-padding">
    <mat-list>
      <mat-list-item>
        <mat-icon matListItemIcon>email</mat-icon>
        <span matListItemTitle>{{data?.email || '-'}}</span>
        <span matListItemLine>Email</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>assignment_ind</mat-icon>
        <span matListItemTitle>{{data?.ssn || '-'}}</span>
        <span matListItemLine>Social security number</span>
      </mat-list-item>
      <mat-list-item>
        <mat-icon matListItemIcon>location_on</mat-icon>
        <span matListItemTitle>{{data?.address?.line1}}</span>
        <span matListItemLine>{{data?.address?.city}}, {{data?.address?.state}} {{data?.address?.zip}}</span>
        <span *ngIf="data?.address?.line2"
              matListItemLine>{{data?.address?.line2}}</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.mobilePhone">
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.mobilePhone}}</span>
        <span matListItemLine>Mobile phone - MFA</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.mobilePhoneUnverified">
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.mobilePhoneUnverified}}</span>
        <span matListItemLine>Mobile phone - MFA</span>
        <span matListItemMeta
              class="unverified-phone">
          <ifp-customer-phone-status-icon-chip status="unverified"></ifp-customer-phone-status-icon-chip>
        </span>
      </mat-list-item>
      <mat-list-item *ngIf="data.preferredPhone">
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.preferredPhone}}</span>
        <span matListItemLine>Preferred phone</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.businessPhone">
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.businessPhone}}</span>
        <span matListItemLine>Business phone</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.homePhone">
        <mat-icon matListItemIcon>phone</mat-icon>
        <span matListItemTitle>{{data?.homePhone}}</span>
        <span matListItemLine>Home phone</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.birthdate">
        <mat-icon matListItemIcon>cake</mat-icon>
        <span matListItemTitle>{{data.birthdate | date: 'M/d/yyyy' }}</span>
        <span matListItemLine>Birthdate</span>
      </mat-list-item>
      <mat-list-item *ngIf="data.yearOfBarAdmission">
        <mat-icon matListItemIcon>gavel</mat-icon>
        <span matListItemTitle>{{data.yearOfBarAdmission}}</span>
        <span matListItemLine>Year of Bar admission</span>
      </mat-list-item>
      <ng-container *ngIf="data?.status === CustomerStatus.Pending && canSendEmail">
        <button color="primary"
                class="activation-button"
                mat-button
                (click)="resendInvitation()">ACTIVATION REMINDER</button>
      </ng-container>
    </mat-list>
  </mat-card-content>
</mat-card>
